import React from 'react';
import { EmptyView, Flex, IconEmptyProduct } from '@banhala/ui-kit';
import { useGoodsPieces } from '../queries/useGoodsPieces';
import { useGetMeasureValues } from '../hooks/useGetMeasureValues';
import { MeasurementTop } from './MeasurementTop';
import { MeasurementBottom } from './MeasurementBottom';
import { isNil } from 'shared/src/utils';

interface PiecesInfoProps {
  hideOnEmpty?: boolean;
}

export const PiecesInfo: React.FC<PiecesInfoProps> = ({ hideOnEmpty }) => {
  const { data: goodsPieces } = useGoodsPieces();
  const getMeasureValues = useGetMeasureValues();

  if (isNil(goodsPieces)) return null;

  const isEmptyMeasurement =
    goodsPieces.length === 0 ||
    goodsPieces.every(
      piece =>
        piece.measurement.sizes.length === 0 &&
        piece.measurement.extracted_sizes.length === 0 &&
        piece.goods_extracted_measure_image == null,
    );

  if (isEmptyMeasurement) {
    if (hideOnEmpty) return null;

    return (
      <Flex.Center padding={{ vertical: 176 }}>
        <EmptyView
          icon={<IconEmptyProduct width={72} height={72} />}
          title={'실측 정보가 없는 상품이에요'}
        />
      </Flex.Center>
    );
  }

  return (
    <Flex gap={24} padding={{ top: 12, bottom: 12 }}>
      {goodsPieces.map((piece, index) => {
        const { measureValues, goodsExtractedMeasureImage } =
          getMeasureValues(piece);
        return (
          <Flex padding={{ horizontal: 16 }} key={index}>
            {(measureValues.length !== 0 || goodsExtractedMeasureImage) && (
              <MeasurementTop piece={piece} />
            )}
            <MeasurementBottom piece={piece} />
          </Flex>
        );
      })}
    </Flex>
  );
};
